export default class CartaoModel {
    constructor(codigoCartao, numeroChip, digitoCartao, cpf) {                 
        this.codigoCartao = codigoCartao;
        this.numeroChip = numeroChip;
        this.digitoCartao = digitoCartao;
        this.cpf = cpf;     
    };
}